import React from 'react';
import HeaderWrapper from 'mf-react-ui/HeaderWrapper';
import Logo from 'mf-react-ui/Logo';
import TopBar from 'mf-react-ui/TopBar';
import HeaderActionBar from '../draft/HeaderActionBar/HeaderActionBar';
import NavMain from '../draft/NavMain/NavMain';
import auth from '../../features/auth/utils/mym';
import { AppRoute } from '../../const';
import { EventCat, EventGTM, EventId, EventName, trackEventBound } from '../../utils/ga';
import './Header.scss';

type Props = {
  msisdn: string | null;
  onLogoutClick: () => void;
};

const Header: React.FC<Props> = (props) => {
  const { msisdn, onLogoutClick } = props;
  const handleMyOrdersItemMenuClick = (): void => {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    window.matchMedia('(min-width: 768px)').matches
      ? trackEventBound(
          EventGTM.UseNavigations,
          EventId.ClickMyOrdersItemMenuHeader,
          EventCat.GiftDesktop,
          EventName.ClickLink,
          // eslint-disable-next-line sonarjs/no-duplicate-string
          'Мои заказы'
        )
      : trackEventBound(
          EventGTM.UseNavigations,
          EventId.ClickMyOrdersItemMenuHeader,
          EventCat.GiftMobile,
          EventName.ClickLink,
          'Мои заказы'
        );
  };

  return (
    <>
      <TopBar
        msisdn={msisdn}
        onLoginClick={() => auth.authOTP()}
        onLogoutClick={() => onLogoutClick()}
      />
      <HeaderWrapper>
        <Logo serviceTitle="Дари эмоции" />
        {msisdn && (
          <HeaderActionBar>
            <div className="header__navigation">
              <NavMain
                menuSection={{
                  items: [
                    {
                      title: 'Мои заказы',
                      to: AppRoute.ORDERS,
                      onClick: handleMyOrdersItemMenuClick,
                    },
                  ],
                }}
              />
            </div>
          </HeaderActionBar>
        )}
      </HeaderWrapper>
    </>
  );
};

export default Header;
